import { render, staticRenderFns } from "./inmitStratQuset.vue?vue&type=template&id=6b360133&scoped=true&"
import script from "./inmitStratQuset.vue?vue&type=script&lang=js&"
export * from "./inmitStratQuset.vue?vue&type=script&lang=js&"
import style0 from "./inmitStratQuset.vue?vue&type=style&index=0&id=6b360133&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b360133",
  null
  
)

export default component.exports